import { render } from "./ArrowRightSvg.vue?vue&type=template&id=479dd5a3"
import script from "./ArrowRightSvg.vue?vue&type=script&lang=js"
export * from "./ArrowRightSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__